import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import clsx from 'clsx';
import * as actions from 'containers/Leads/actions';

import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import ErrorModal from 'components/Modal/ConfirmationModal';
import ArchiveModal from './Leads.ArchiveModal';

/**
 * @description: Leads Status Dropdown
 * @param {*}
 * @return {*}
 */
export const LeadsStatusDropdown = ({ leadId, lostReasons, statuses, active }) => {
  const dispatch = useDispatch();
  const { updateLeadStatus } = bindActionCreators(actions, dispatch);
  const [showDropdown, toggleDropdown] = useState(false);
  const [selected, setSelected] = useState(active);
  const [archiveOpened, setArchiveOpened] = useState(false);
  const [statusError, setStatusError] = useState(false);

  const activeStatusName = statuses.filter(status => status.id === active)[0]?.name;
  const lostStatus = statuses.filter(status => status.name === 'Lost')[0];

  useEffect(() => {
    setSelected(active);
  }, [active]);

  const updateStatus = (e, statusId) => {
    e.stopPropagation();
    updateLeadStatus({
      errorPolicy: 'all',
      variables: {
        id: leadId,
        input: {
          status: '',
          leadCustomStatusId: parseInt(statusId, 10),
        },
      },
      current: active,
    });
    dismiss();
  };

  const show = () => {
    toggleDropdown(true);
  };

  const dismiss = () => {
    toggleDropdown(false);
  };

  const openArchive = (e) => {
    e.stopPropagation();
    dismiss();
    setArchiveOpened(true);
  };

  const renderStatusMenu = () => {
    return (
      <>
        {statuses.map(status => {
          if (status.name === 'Lost') {
            return (
              <button
                key={`lead-status--${status.id}`}
                className={clsx(
                  'ap-dropdown__button',
                  'ap-dropdown__button--status',
                  'button--unstyled',
                  { 'selected': status.id === selected },
                )}
                onClick={(e) => openArchive(e)}
              >
                {status.name}
              </button>
            );
          }
          return (
            <button
              key={`lead-status--${status.id}`}
              className={clsx(
                'ap-dropdown__button',
                'ap-dropdown__button--status',
                'button--unstyled',
                { 'selected': status.id === selected },
              )}
              onClick={(e) => updateStatus(e, status.id)}
            >
              {status.name}
            </button>
          );
        })}
      </>
    );
  };

  const trigger = (
    <DropdownButton
      className={clsx(
        'button--unstyled',
        'button--status',
        { 'new': activeStatusName === 'New' },
      )}
      showIcon
    >
      {activeStatusName}
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={showDropdown}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        menuClass="lead-data-dropdown"
      >
        {renderStatusMenu()}
      </APResponsiveDropdown>
      {archiveOpened && (
        <ArchiveModal
          leadId={leadId}
          lostReasons={lostReasons}
          lostStatus={lostStatus}
          active={active}
          archiveOpened={archiveOpened}
          setArchiveOpened={setArchiveOpened}
        />
      )}
      {statusError && (
        <ErrorModal
          visible={statusError}
          title="Status couldn't be changed at this time. Please try again."
          onClose={() => setStatusError(false)}
          actions={(
            <button
              onClick={() => setStatusError(false)}
              className="button"
            >
              Close
            </button>
          )}
        />
      )}
    </>
  );
};

export const renderLeadsStatusDropdown = (leadId, statuses, active, refreshIndex) => {
  return (
    <LeadsStatusDropdown
      leadId={leadId}
      statuses={statuses}
      active={active}
      refreshIndex={refreshIndex}
    />
  );
};
